module.exports = __webpack_public_path__ + "static/media/circlephoto.09efbfe5.png";